const STORAGE_PREFIX = 'chat_course_';

export const chatStorage = {
  /**
   * Salva un messaggio nello storico
   */
  saveMessage(courseId, userId, message) {
    if (!userId) return;
    const history = this.getHistory(courseId, userId);
    history.push({
      ...message,
      timestamp: message.timestamp || new Date().toISOString(),
    });
    const key = `${STORAGE_PREFIX}user_${userId}_course_${courseId}`;
    localStorage.setItem(key, JSON.stringify(history));
  },

  /**
   * Recupera lo storico messaggi
   */
  getHistory(courseId, userId) {
    if (!userId) {
      console.warn('chatStorage: userId mancante, impossibile recuperare storico');
      return [];
    }
    const key = `${STORAGE_PREFIX}user_${userId}_course_${courseId}`;
    const data = localStorage.getItem(key);
    console.log(`chatStorage: Loading history from ${key}`, data ? 'Found data' : 'No data');
    return data ? JSON.parse(data) : [];
  },

  /**
   * Pulisce lo storico
   */
  clearHistory(courseId, userId) {
    if (!userId) return;
    localStorage.removeItem(`${STORAGE_PREFIX}user_${userId}_course_${courseId}`);
  },

  /**
   * Salva modalità attiva
   */
  saveActiveMode(courseId, userId, mode) {
    if (!userId) return;
    localStorage.setItem(`${STORAGE_PREFIX}user_${userId}_course_${courseId}_mode`, mode || '');
  },

  /**
   * Recupera modalità attiva
   */
  getActiveMode(courseId, userId) {
    if (!userId) return null;
    return localStorage.getItem(`${STORAGE_PREFIX}user_${userId}_course_${courseId}_mode`) || null;
  },

  /**
   * Salva funzioni attive
   */
  saveActiveFunctions(courseId, userId, functions) {
    if (!userId) return;
    localStorage.setItem(
      `${STORAGE_PREFIX}user_${userId}_course_${courseId}_functions`,
      JSON.stringify(functions)
    );
  },

  /**
   * Recupera funzioni attive
   */
  getActiveFunctions(courseId, userId) {
    if (!userId) return [];
    const data = localStorage.getItem(`${STORAGE_PREFIX}user_${userId}_course_${courseId}_functions`);
    return data ? JSON.parse(data) : [];
  },
};
